/**
 * Certifications & partners filter.
 *
 * Toggles the active tab and its matching logo panel.
 */
const initCertifications = (section) => {
  const tabs = Array.from(section.querySelectorAll('[data-cert-tab]'));
  const panels = Array.from(section.querySelectorAll('[data-cert-panel]'));

  if (!tabs.length || !panels.length) {
    return;
  }

  const activate = (index) => {
    tabs.forEach((tab) => {
      const isActive = tab.dataset.certTab === String(index);
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.certPanel === String(index);
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => activate(tab.dataset.certTab));
  });
};

const initAll = () => {
  document.querySelectorAll('.certifications').forEach((section) => {
    if (section.dataset.certInitialized) {
      return;
    }

    section.dataset.certInitialized = 'true';
    initCertifications(section);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
